import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCategories,
  createCategory,
  deleteCategory,
  updateCategory,
} from "../../../redux/actions/category";
import { useToast } from "../../Layout/Toast/ToastProvider";
import {Loader} from '../../Layout/Loader';

import "./CategoriesTab.scss";

const CategoriesTab = () => {
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const { categories = [], isLoading, error } = useSelector(
    (state) => state.category || {}
  );

  const [categoryName, setCategoryName] = useState("");
  const [editingCategoryId, setEditingCategoryId] = useState(null);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [selectedParents, setSelectedParents] = useState([]);

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      showToast(error, "error");
    }
  }, [error, showToast]);

  const handleCreateCategory = (e) => {
    e.preventDefault();
    if (!categoryName.trim()) {
      showToast("Заповніть ім'я Категорії!", "error");
      return;
    }
    dispatch(createCategory({ name: categoryName })).then(() => {
      showToast("Категорію успішно створено!", "success");
      setCategoryName("");
    });
  };

  const startEditing = (id, name, parents) => {
    setEditingCategoryId(id);
    setNewCategoryName(name);
    setSelectedParents(parents || []);
  };

  const handleUpdateCategory = (e) => {
    e.preventDefault();
    if (!newCategoryName.trim()) {
      showToast("Ім'я Категорії не може бути пусте!", "error");
      return;
    }
    dispatch(
      updateCategory(editingCategoryId, {
        name: newCategoryName,
        parents: selectedParents,
      })
    ).then(() => {
      showToast("Категорію успішно оновлено!", "success");
      setEditingCategoryId(null);
      setNewCategoryName("");
      setSelectedParents([]);
    });
  };

  const handleDeleteCategory = (id) => {
    if (window.confirm("Ви впевнені що хочете видалити цю Категорію?")) {
      dispatch(deleteCategory(id)).then(() =>
        showToast("Категорію успішно видалено!", "success")
      );
    }
  };

  return (
    <div className="categories-tab">
      <h2 className="categories-tab__heading">Керування категоріями</h2>

      <form onSubmit={handleCreateCategory} className="categories-tab__create-form">
        <input
          type="text"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          placeholder="Введіть ім'я категорії"
          className="categories-tab__create-form__input"
        />
        <button
          type="submit"
          className="categories-tab__create-form__submit-btn"
          disabled={isLoading}
        >
          {isLoading ? "Довання..." : "Додати категорію"}
        </button>
      </form>

      {isLoading ? (
        <Loader/>
      ) : categories.length > 0 ? (
        <ul className="categories-tab__list">
          {categories.map((category) => (
            <li key={category._id} className="categories-tab__list__item">
              {editingCategoryId === category._id ? (
                <form
                  onSubmit={handleUpdateCategory}
                  className="categories-tab__list__item__item__edit-form"
                >
                  <input
                    type="text"
                    value={newCategoryName}
                    onChange={(e) => setNewCategoryName(e.target.value)}
                    className="categories-tab__list__item__item__edit-form__edit-input"
                    placeholder="Ім'я Категорії"
                  />

                  <div className="categories-tab__list__item__buttons">
                    <button
                      type="submit"
                      className="categories-tab__button categories-tab__button--save"
                    >
                      Зберегти
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setEditingCategoryId(null);
                        setSelectedParents([]);
                      }}
                      className="categories-tab__button categories-tab__button--cancel"
                    >
                      Скасувати
                    </button>
                  </div>
                </form>
              ) : (
                <div className="categories-tab__item-view">
                  <span>{category.name}</span>
                  <div className="categories-tab__list__item__buttons">
                    <button
                      onClick={() =>
                        startEditing(category._id, category.name, category.parents)
                      }
                      className="categories-tab__button categories-tab__button--edit"
                    >
                      Редагувати
                    </button>
                    <button
                      onClick={() => handleDeleteCategory(category._id)}
                      className="categories-tab__button categories-tab__button--delete"
                    >
                      Видалити
                    </button>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p>Категорій не знайдено. Створіть нову категорію ;)</p>
      )}
    </div>
  );
};

export default CategoriesTab;
